import { createFileRoute } from "@tanstack/react-router";
import SidingRepair from "@/pages/services/SidingRepair";
import { seo, breadcrumbSchema, absoluteUrl } from "@/lib/seo";
import { buildFaqPageSchema, buildServiceSchema } from "@/lib/schema";
import { sidingRepairFaqs } from "@/data/serviceFaqs";

export const Route = createFileRoute("/_site/services/siding-repair")({
  head: () =>
    seo({
      title: "Siding Repair in Minneapolis, MN | Cedar Creek Construction",
      description:
        "Siding repair in Minneapolis & the Twin Cities—storm and hail damage, cracked panels, rot, and trim. Color-matched, weather-tight repairs. Call (612) 298-9865.",
      path: "/services/siding-repair",
      jsonLd: [
        breadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Services", path: "/siding" },
          { name: "Siding Repair", path: "/services/siding-repair" },
        ]),
        buildServiceSchema({
          name: "Siding Repair in Minneapolis, MN",
          serviceType: "Siding Repair",
          url: absoluteUrl("/services/siding-repair"),
          description:
            "Siding repair for storm and hail damage, cracked panels, rot, and trim on homes across Minneapolis and the Twin Cities metro.",
        }),
        buildFaqPageSchema(sidingRepairFaqs),
      ],
    }),
  component: SidingRepair,
});
